import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../core/helper/auth.guard';
import { utComponent } from './ut.component';

const utRoutes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: utComponent,
    children: [
      {
        loadChildren: "../forms/home/home.module#HomeModule",
        path: "home"
      },
      {
        loadChildren: "../forms/utrole/utrolelisting/utrolelisting.module#UtrolelistingModule",
        path: "utrole"
      },
      {
        loadChildren: "../forms/utuser/utuserlisting/utuserlisting.module#UtuserlistingModule",
        path: "utuser"
      },
      {
        loadChildren: "../forms/utmodule/utmodule.module#UtmoduleModule",
        path: "utmodule"
      },
      {
        loadChildren: "../forms/utdoctypesetup/utdoctypesetup.module#UtdoctypesetupModule",
        path: "utdoctypesetup"
      },
      {
        loadChildren: "../forms/utbusinessobject/utbusinessobject.module#UtbusinessobjectModule",
        path: "utbusinessobject"
      },
      {
        loadChildren: "../forms/utnumbersetting/utnumbersetting.module#UtnumbersettingModule",
        path: "utnumbersetting"
      },
      {
        loadChildren: "../forms/utinstance/utinstance.module#UtinstanceModule",
        path: "utinstance"
      },
      {
        loadChildren: "../forms/utmenus/utmenus.module#UtmenusModule",
        path: "utmenu"
      },
      {
        loadChildren: "../forms/menu-screen/menu-screen.module#MenuScreenModule",
        path: "menuscreen"
      },
      {
        loadChildren: "../forms/utlisterconfighdr/utlisterconfighdr.module#UtlisterconfighdrModule",
        path: "utlisterconfighdr"
      },
      {
        loadChildren: "../forms/utreporthdr/utreporthdrlist/utreporthdrlist.module#UtreporthdrlistModule",
        path: "utreporthdr"
      },
      {
        loadChildren: "../forms/utdocsubtypesetup/utdocsubtypesetup.module#UtdocsubtypesetupModule",
        path: "utdocsubtypesetup"
      },
      {
        loadChildren: "../forms/systempolicy/systempolicy.module#SystemPolicyModule",
        path: "systempolicy"
      },
      {
        loadChildren: "../forms/utapp/utapp.module#UtappModule",
        path: "utapp"
      },
      {
        loadChildren: "../forms/utdatabase/utdatabase.module#UtdatabaseModule",
        path: "utdatabase"
      },
      {
        loadChildren: "../forms/utmenuhdr/utmenuhdr.module#UtmenuhdrModule",
        path: "utmenuhdr"
      },

      {
        loadChildren: "../forms/utnumber/utnumberlist.module#UtnumberlistModule",
        path: "utnumberhdr"
      },

      {
        loadChildren: "../forms/utdocsubtypeassign/utdocsubtypeassignlist.module#UtdocsubtypeassignlistModule",
        path: "utdocsubtypeassign"
      },

      {
        loadChildren: "../forms/client/client.module#ClientModule",
        path: "utclient"
      },
      {
        loadChildren: "../forms/utform/utform.module#UtformModule",
        path: "utform"
      },
      {
        loadChildren: "../forms/utscreen/utscreen.module#UtscreenModule",
        path: "utscreen"
      },

    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(utRoutes)],
  exports: [RouterModule]
})
export class utRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/shell/ut/ut.routing.ts